import React from "react";

const Sagrilaft = () => {
  return (
    <section
      style={{
        margin: "150px auto",
        display: "grid",
      }}
      className="centrar"
    >
      <img
        src="https://53fde1b606cff91e7a3b23ff9c242152.grupoalianzacolombia.com/uploads/images_web/CERTIFICACION__SAGRILAFT_Y_PTEE_2025%201_page-0001.jpg"
        alt="SAGRILAFT_1"
        onContextMenu={(e) => e.preventDefault()}
        onDragStart={(e) => e.preventDefault()}
        className="img-fluid centrar"
      />
      <img
        src="https://53fde1b606cff91e7a3b23ff9c242152.grupoalianzacolombia.com/uploads/images_web/CERTIFICACION__SAGRILAFT_Y_PTEE_2025%201_page-0002.jpg"
        alt="SAGRILAFT_2"
        onContextMenu={(e) => e.preventDefault()}
        onDragStart={(e) => e.preventDefault()}
        className="img-fluid"
      />
    </section>
  );
};

export default Sagrilaft;
